import { connect, MapStateToProps } from 'react-redux'
import { Props } from './BuildabilitySwitcher'
import { changeBuildabilityType } from '../../redux/actions/app/buildabilitySwitcher.actions'
import buildabilityTypesSelector
    from '../../redux/selectors/buildability/buildabilityTypesSelector'
import currentBuildabilityTypeSelector
    from '../../redux/selectors/buildability/currentBuildabilityTypeSelector'

type StateProps = Pick<Props, 'availableBuildabilityTypes' | 'currentBuildabilityType'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state) => ({
    availableBuildabilityTypes: buildabilityTypesSelector(state),
    currentBuildabilityType: currentBuildabilityTypeSelector(state),
})

type DispatchProps = Pick<Props, 'changeBuildabilityType'>

const mapDispatchProps: DispatchProps = {
    changeBuildabilityType: changeBuildabilityType,
}

export default connect(mapStateToProps, mapDispatchProps)
